<template>
  <BaseModal :modal-class="'undo-share-diet-modal'" @close="close">
    <template #title>Cofnąć udostępnienie jadłospisu?</template>
    <div class="undo-share-content">
      <p class="undo-share-description">
        Jadłospis przestanie być widoczny dla pacjenta w aplikacji mobilnej.
      </p>
    </div>
    <template #actions>
      <StyledButton variant="outline" @click.once="close">Anuluj</StyledButton>
      <StyledButton :disabled="sending" @click.once="onConfirm">Potwierdź</StyledButton>
      <BaseLoader v-if="sending" class="base-loader--size-12" />
    </template>
  </BaseModal>
</template>

<script lang="ts" setup>
  import { ref } from 'vue'

  import BaseLoader from '@/components/BaseLoader.vue'
  import BaseModal from '@/components/BaseModal.vue'
  import { StyledButton } from '@/components/StyledButton'
  import { dietsService } from '@/services/dietsService'
  import { useGlobalStore } from '@/store/globalStore'
  import { reportError } from '@/utils/reportError'

  const props = defineProps({
    dietId: {
      required: true,
      type: Number,
    },
    patientId: {
      required: true,
      type: Number,
    },
  })

  const emit = defineEmits(['close', 'success'])

  const globalStore = useGlobalStore()
  const sending = ref(false)

  const close = () => {
    emit('close')
  }

  const onConfirm = async () => {
    try {
      sending.value = true
      await dietsService.unpublishDiet(props.dietId)

      globalStore.createMessage({
        title: 'Pacjent nie ma już dostępu do tego jadłospisu',
      })

      emit('success')
      close()
    } catch (error) {
      reportError(error, 'Error while unpublishing diet', {
        dietId: props.dietId,
        patientId: props.patientId,
      })
      globalStore.createMessage({
        title: 'Nie udało się cofnąć udostępnienia jadłospisu',
        type: 'error',
      })
    } finally {
      sending.value = false
    }
  }
</script>

<style scoped>
  .undo-share-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .undo-share-description {
    font-size: 14px;
    line-height: 1.5;
    color: var(--color-tertiary-text);
  }
</style>
